import type { Essentials, ISiteContext } from '../../models';
import type { getReviewsSectionResponse } from './app-page-sections/reviews/api/reviews-api';
import { getReviewsSectionData } from './app-page-sections/reviews/api/reviews-api';
import { queryApp, queryMarketListing } from './app-page-api.utils';
import { AppType } from './app-page-sections/reviews/types';
import { getAppNotification } from './app-page-sections/notifications/api';
import type { AppNotification } from './app-page-sections/notifications/types';

export type getAppPageDataResponse = {
  app: {
    id: string;
    name: string;
    icon: string;
    type: AppType;
  };
  reviews: getReviewsSectionResponse;
  notification: AppNotification | null;
};

export async function getAppPageData({
  httpClient,
  rpcClient,
  slug,
  editorType,
}: {
  httpClient: Essentials['httpClient'];
  rpcClient?: Essentials['rpcClient'];
  slug: string;
  editorType: ISiteContext['editorType'];
}): Promise<getAppPageDataResponse> {
  const appData = await queryApp({ httpClient, rpcClient, slug });
  const marketListing = await queryMarketListing({
    httpClient,
    rpcClient,
    appId: appData.id,
  });

  const [reviews, notification] = await Promise.all([
    getReviewsSectionData({ httpClient, rpcClient, appId: appData.id }),
    getAppNotification({
      httpClient,
      rpcClient,
      app: {
        id: appData.id,
        name: marketListing.basicInfo?.name ?? '',
      },
      editorType,
    }),
  ]);

  return {
    app: {
      id: appData.id,
      name: appData?.name,
      icon: marketListing.assetsMap?.appIcon?.assets?.[0]?.url ?? '',
      type: appData?.wixApp ? AppType.WIX_APP : AppType.TPA,
    },
    reviews,
    notification,
  };
}
